var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:_vm.$style.section},[(_vm.doc)?_c('div',[_c('div',{class:[_vm.$style.document],domProps:{"innerHTML":_vm._s(_vm.doc.content)}})]):(!_vm.setPageLoading)?_c('div',[_vm._v(_vm._s(_vm.$t('documentNotFound')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }